import { defineMessage, useIntl } from 'react-intl'

import { getTranslatedValidation } from '@subaio/components/src/HookForm'
import { refine, type Struct } from '@subaio/validation'

export const useValidation = () => {
	const { formatMessage } = useIntl()

	return {
		...getTranslatedValidation({
			requiredMessage: formatMessage(
				defineMessage({ id: 'inputValidationError.required', defaultMessage: 'This field is required' }),
			),
			invalidEmailMessage: formatMessage(
				defineMessage({ id: 'inputValidationError.invalidEmail', defaultMessage: 'Has to be a valid email' }),
			),
			invalidNumberMessage: formatMessage(
				defineMessage({ id: 'inputValidationError.invalidNumber', defaultMessage: 'Has to be a number' }),
			),
		}),
		withLength: (struct: Struct<string, any>, minLength: number, maxLength: number) =>
			refine(struct, 'length', (value) => {
				if (value.length < minLength) {
					return formatMessage(
						defineMessage({
							id: 'formFields.input.minLength',
							defaultMessage: 'Needs to be at least {minLength} characters long',
						}),
						{ minLength },
					)
				}
				if (value.length > maxLength) {
					return formatMessage(
						defineMessage({
							id: 'formFields.input.maxLength',
							defaultMessage: 'Cannot be more than {maxLength} characters long',
						}),
						{ maxLength },
					)
				}
				return true
			}),
		passwordsMatchMessage: formatMessage(
			defineMessage({
				id: 'inputValidationError.passwordsMatch',
				defaultMessage: 'The passwords do not match',
			}),
		),
	}
}
